export default __webpack_public_path__ + "static/backdrop-bg-mobile-fc74756cd26b69b4b8275813d50ed708.jpg";